import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'A101',
  logo: { name: 'A101', src: '/logo/a101card.png' },
  portrait: { src: '/photo/portrait-orhan-daglioglugil.png', alt: 'Orhan Dağlıoğlugil' },
  quote: [
    'We have been busy with digital transformation at A101 for the last 2 years focusing on '
    + 'the different dimensions of customer experience, operational improvements, '
    + 'innovation, and digital culture. Digitalisation is happening in all aspects of daily '
    + 'life. We wish to adapt to that and build a roadmap in consideration of country '
    + 'dynamics, retail sector dynamics and our corporate culture. One of the most important '
    + 'aspects of the process was the DMI Digital Maturity Index which allowed us to have a '
    + 'clear picture of where we are and to set our priorities in an objective manner.',
  ],
  attribution: 'Orhan Dağlıoğlugil, CTO',
  story: 'a-101',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 13
